<script lang="ts">
	import { Locale } from "@core/schema/Locale.js";
	import { localeNameMap } from "@core/schema/names/localeNameMap.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";

	const { tenant, pagePath } = getGlobalTemplateProps();
	const localeAliasMap: Record<Locale, string> = {
		[Locale.en]: "EN",
		[Locale.cs]: "CZ",
	};
</script>

<div class="flex flex-col gap-4 size-fit">
	{#each Object.values(Locale).filter((locale) => locale !== tenant.locale) as targetLocale (targetLocale)}
		<a
			href={pagePath[targetLocale]}
			referrerpolicy="no-referrer"
			rel="noreferrer"
			class={[
				"size-16 border-white/16 hover:border-white transition-colors",
				"flex justify-center items-center rounded-full border",
			]}
			title={localeNameMap[targetLocale][tenant.locale]}
		>
			<span class="text-white text-sm/4 font-medium">{localeAliasMap[targetLocale]}</span>
		</a>
	{/each}
</div>
